import React from 'react';
import ToolbarPopover from './ToolbarPopover';

const ColumnPopover = ({
  id,
  open,
  anchorEl,
  onClose,
  columns,
  searchText,
  onSearchChange,
  onColumnToggle,
  isColumnVisible,
  onSelectAll
}) => {
  const filteredColumns = columns.filter(column =>
    column.headerName.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <ToolbarPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      title="Column Visibility"
    >
      <div className="p-4">
        <div className="mb-4">
          <input
            type="text"
            value={searchText}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search columns..."
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>
        <div className="space-y-2 max-h-60 overflow-auto">
          {filteredColumns.map(column => (
            <div key={column.field} className="flex items-center">
              <input
                type="checkbox"
                id={`column-${column.field}`}
                checked={isColumnVisible(column.field)}
                onChange={() => onColumnToggle(column.field)}
                className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-0 focus:outline-none"
              />
              <label
                htmlFor={`column-${column.field}`}
                className="ml-2 block text-sm text-gray-900"
              >
                {column.headerName}
              </label>
            </div>
          ))}
          {filteredColumns.length === 0 && (
            <div className="text-sm text-gray-500 text-center py-2">
              No columns found
            </div>
          )}
        </div>
        <div className="mt-4 flex justify-between items-center">
          <button
            onClick={onSelectAll}
            className="text-sm text-indigo-600 hover:text-indigo-700 font-medium"
          >
            Select All
          </button>
        </div>
      </div>
    </ToolbarPopover>
  );
};

export default React.memo(ColumnPopover);
